import styled from 'styled-components'
import Section from './Section'
import media from 'css-in-js-media'
import React from 'react'
import Container from './Container'
import Heading from './Heading'
import { BodyCopy } from './Typography'
import { Col, Row } from 'react-styled-flexboxgrid'

export const X2CopySection = styled(Section)`
    ${Col}:not(:last-child) {
        ${media('<desktop')} {
            padding-bottom: 25px;
        }
    }
`

export const X2Copy: React.FC<{
    data: object
}> = ({ data }) => {
    const { copyComponents } = data
    return (
        <>
            {copyComponents && (
                <X2CopySection>
                    <Container narrow>
                        <Row>
                            {copyComponents.map((d, i) => {
                                return (
                                    <Col md={6} key={i}>
                                        <BodyCopy
                                            dangerouslySetInnerHTML={{
                                                __html: d.copy.childMarkdownRemark.html,
                                            }}
                                        />
                                    </Col>
                                )
                            })}
                        </Row>
                    </Container>
                </X2CopySection>
            )}
        </>
    )
}
